module.exports = __webpack_public_path__ + "static/people_and_change-9f413b81b9da47d62bd71957221b74af.jpg";